<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Vehicle Monitoring Page</h4>
    <hr>
    <Spinner v-if="isFetching" />
    <div v-if="!isFetching">
      <b-row class="mb-3">
        <b-col>
          <span class="font-weight-bold">
            {{ vehicle.licensePlate }} - {{ vehicle.make }} {{ vehicle.model }}
          </span>
        </b-col>
        <b-col>
          <div class="font-weight-bold text-right">
            <b-btn
              variant="secondary"
              size="sm"
              @click="$router.push({ name: 'VehicleList' })">
              Back
            </b-btn>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col>
          <span class="mr-5">Chasis Number: {{ vehicle.chasisNumber }}</span>
          <span :class="{'d-block': $mq === 'sm'}">Engine Number: {{ vehicle.engineNumber }}</span>
        </b-col>
        <b-col :class="{'text-right': $mq !== 'sm'}">
          <span>Fleet Partner: {{ vehicle.fleetPartner }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs>
            <b-tab title="Service Monitoring">
              <ServiceMonitoring :vehicle="vehicle" @submitted="fetchData" />
            </b-tab>
            <b-tab v-if="$hasRole(serviceModule, 'Admin')" title="Service History" lazy>
              <ServiceHistory :vehicle="vehicle" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Spinner } from '@/components'
import ServiceMonitoring from './ServiceMonitoring'
import ServiceHistory from './ServiceHistory'

export default {
  name: 'VehicleMonitoring',
  components: {
    Spinner,
    ServiceMonitoring,
    ServiceHistory
  },
  data() {
    return {
      serviceModule: process.env.VUE_APP_MODE === 'production' ? 'CCPL - VMTS v2' : 'OPS - VMTS REVAMP',
      vehicle: {},
      isFetching: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.isFetching = true
      const query = this.$route.query
      this.$store.dispatch('vmts/getServiceMonitoring', query)
        .then((data) => {
          this.isFetching = false
          this.vehicle = data
        })
    },
  }
}
</script>

<style>

</style>